export default __webpack_public_path__ + "static/media/home-hactoberfestLogo.5b943cd8.svg";